/**
 * The stream type for the video. The video
 * player controls will change depending on
 * the stream type.
 *
 * https://docs.mux.com/guides/player/play-your-assets#adaptive-controls
 */
export const MUX_PLAYER_STREAM_TYPE = {

	/**
	 * Video on demand.
	 * Use for streaming static videos.
	 */
	ON_DEMAND: 'on-demand',

	/**
	 * A regular live stream.
	 */
	LIVE: 'live',

	/**
	 * A low latency live stream.
	 */
	LOW_LATENCY_LIVE: 'll-live',

	/**
	 * A live stream that allows the user to
	 * seek back.
	 */
	LIVE_DVR: 'live:dvr',

	/**
	 * A low latency live stream that allows the
	 * user to seek back.
	 */
	LOW_LATENCY_LIVE_DVR: 'll-live:dvr',

};

/**
 * Type constants for Library Video.
 */
export const ENUMS_VIDEO = {

	PROVIDER: {

		/**
         * The third party video provider, Mux.
         * This is currently our only video provider.
         */
		MUX: 'mux',
	},

	STATUS: {

		/**
		 * A direct upload has been initialized and is waiting to receive a file
		 * for processing.
		 */
		WAITING: 'waiting',

		/**
		 * The encountered an error during processing.
		 */
		ERRORED: 'errored',

		/**
		 * The video is processing and is not ready for playback.
		 */
		PREPARING: 'preparing',

		/**
		 * The video is successfully created and ready for playback.
		 */
		READY: 'ready',

		/**
		 * The video was deleted from the external provider.
		 */
		DELETED: 'deleted',

	}

};

/**
 * The list of languages that Mux supports for auto-generated captions
 * on video on-demand assets
 */
export const MUX_AUTO_GENERATED_LANGUAGES = [
	'en', 'es', 'it', 'pt', 'de', 'fr', 'pl', 'ru', 'nl', 'ca', 'tr',
	'sv', 'uk', 'no', 'fi', 'sk', 'el', 'cs', 'hr', 'da', 'ro', 'bg',
];

/**
 * The master access property options for requesting master access to
 * an asset. Once ready, a URL will be available for 24 hours.
 *
 * https://docs.mux.com/guides/download-for-offline-editing
 */
export const MUX_VIDEO_MASTER_ACCESS = {
	TEMPORARY: 'temporary',
	NONE: 'none',
};

/**
 * The master access status on the Mux asset.
 */
export const MUX_VIDEO_MASTER_STATUS = {
	READY: 'ready',
	PREPARING: 'preparing',
	ERRORED: 'errored',
};
